/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_DashboardInputs */

const en_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const zh_hans1_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`控制台`)
};

const pt_br2_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel`)
};

const es_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const fr_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

const de_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ru_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель`)
};

const it_footer_dashboard = /** @type {(inputs: Footer_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Footer_DashboardInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_dashboard = /** @type {((inputs?: Footer_DashboardInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_DashboardInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_dashboard(inputs)
	if (locale === "pt-BR") return pt_br2_footer_dashboard(inputs)
	if (locale === "es") return es_footer_dashboard(inputs)
	if (locale === "fr") return fr_footer_dashboard(inputs)
	if (locale === "de") return de_footer_dashboard(inputs)
	if (locale === "ru") return ru_footer_dashboard(inputs)
	if (locale === "it") return it_footer_dashboard(inputs)
	return en_footer_dashboard(inputs)
});